module.exports = __webpack_public_path__ + "img/iot-03.557ea1ca.png";